import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button, Typography } from '@mui/material';

import { queueVendorPayablesReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subDays } from '~/services/TimeService';

import ErrorDisplay from '../ErrorDisplay';

const formSchema: RJSFSchema = {
  description: 'Please enter a date to generate the Vendor Payables Report as at that date (inclusive).',
  type: 'object',
  properties: {
    endAt: {
      title: 'Report Date',
      type: 'string',
      format: 'date',
      default: formatDateISO(subDays(1, startOfMonth())),
    },
  },
  required: ['endAt'],
};

const uiSchema = {
  endAt: {
    'ui:widget': 'date',
  },
};

export default function ExportVendorPayablesReportForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event: IChangeEvent) => {
    setError(null);
    setSuccessMessage(false);
    try {
      await queueVendorPayablesReport({
        endAt: event.formData.endAt,
      });
      setSuccessMessage(true);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Form schema={formSchema} uiSchema={uiSchema} onSubmit={handleSubmit} validator={validator} showErrorList={false}>
      <Button type="submit" variant="contained">
        Email Vendor Payables Report
      </Button>

      {error && <ErrorDisplay message={error} />}

      {successMessage && (
        <Alert severity="success">
          <Typography>Your report is queued for delivery and will be emailed shortly.</Typography>
        </Alert>
      )}
    </Form>
  );
}
